import "./Play.css";
import { CSSTransition } from "react-transition-group";
import { useState, useEffect } from "react";
import "../../../components/transitions.css";

import PageTitle from "../../../components/Page Title/PageTitle";
import NavigationBar from "../../../components/navbar/NavigationBar";
import { useNavigate, useLocation } from "react-router-dom";

const HowToPlay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const shouldAnimate = location.state?.fromLanding;
  const [showBox, setShowBox] = useState(false);

  useEffect(() => {
    setShowBox(true); // Trigger enter animation on mount
  }, []);
  const handleCreateAccountClick = () => {
    navigate("/createAccount");
  };
  const handleDownloadClick = () => {
    window.open(
      "https://live.hng-group.com/HnG-setup.exe",
      "_blank",
      "noopener,noreferrer",
    );
    //window.open(
    //  "https://discord.com/channels/1382000411522764983/1382011764794724392",
    //  "_blank",
    //  "noopener,noreferrer",
    //);
  };
  return (
    <div className="pagebackground">
      <NavigationBar />
      <CSSTransition
        in={showBox}
        timeout={500}
        classNames={`${shouldAnimate ? "slide-in-right" : ""}`}
        unmountOnExit
      >
        <div>
          <meta
            name="description"
            content="Play Heroes & Generals again. Download the revival project, get setup guides, fixes, and latest updates."
          ></meta>
          {/*
          <PageTitle title="Want to take part in testing?" />
          */}
          <PageTitle title="Ready to get back in the fight?" />
          <div className="pagebox">
            <div className="play-content">
              {/*<p className="step-block warning">
                <div className="steptext">
                  <div className="warning-title">Important notice</div>In order    
                  to receive an account to participate in closed testing, you    
                  need to send a request{" "}    
                  <a href="/TestingApplication">(click here)</a> to us.    
                </div>
              </p> // comment out for live */}
              <div className="step-block">
                <p className="step">Step 1: Download Client</p>
                <p className="steptext text-wrap">
                  The new client connects directly to our servers and lets you
                  receive the latest updates. It is currently accessible through
                  our discord server.
                  <br />
                </p>
                <button
                  className="btn btn-major"
                  onClick={handleDownloadClick}
                  /*style={{ opacity: 0.4 cursor: "not-allowed" }} // comment out for live*/
                >
                  DOWNLOAD
                </button>
                <p className="steptext-mini text-wrap">
                  If you have any issues with the download, please contact us.
                </p>
              </div>

              <div className="step-block">
                <p className="step">Step 2: Install</p>
                <p className="steptext">
                  Follow the installer wizard instructions to install the game.
                  You might need to download updates after you reach the login
                  screen, check HnG Sync to see if anything is being downloaded
                  there, it might take a while
                </p>
              </div>
              <div className="step-block">
                <p className="step">Step 3: Create Account and Play!</p>
                <button
                  className="btn btn-major"
                  onClick={handleCreateAccountClick}
                  /*style={{ opacity: 0.4, cursor: "not-allowed" }} // comment out for live
                  disabled // comment out for live */
                >
                  PLAY!
                </button>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};
export default HowToPlay;
